import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi";
import { provide, ref } from "vue";

export default function WebConfigStore() {
    const webConfig = ref()
    const isWebConfigLoaded = ref(false)

    let baseUrl = ConfigManager.getBlobUrl() + `/webconfig/tni`;
    BzbsApi.connectBzbsGetBlob(baseUrl + "/web_config.json").subscribe({
        next: (res) => {
            // console.log(res)
            webConfig.value = res.data
            isWebConfigLoaded.value = true
        }
    })

    provide('WebConfigStore', webConfig)

    return {
        webConfig,
        isWebConfigLoaded
    }
}